module.exports = __webpack_public_path__ + "images/backgrounds/fall/large.1a9192d4f601ee88d2c7.jpg";